module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '7smmycik',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
